export const BASE_PATH = '';
export const API_BASE = `${BASE_PATH}/api`;

export interface User {
  id: string;
  email: string;
  fullName: string;
  phone?: string;
  avatarUrl?: string;
  isSuperAdmin: boolean;
  createdAt: string;
}

export interface Organization {
  id: string;
  name: string;
  slug: string;
  description?: string;
  coverImageUrl?: string;
  donationLink?: string;
  youtubeLink?: string;
  readingSourceLink?: string;
  inviteCode: string;
  createdAt: string;
}

export interface Event {
  id: string;
  organizationId: string;
  name: string;
  slug: string;
  description?: string;
  startDate?: string;
  endDate?: string;
  locationName?: string;
  locationMapsUrl?: string;
  locationDirections?: string;
  accommodationInfo?: string;
  /* Hava durumu ve namaz vakitleri için; yönetici bir kez giriyor. */
  latitude?: number;
  longitude?: number;
  /* Diyanet takvimindeki ilçe kodu — namaz vakitleri buradan. */
  prayerDistrictId?: string;
  inviteCode: string;
  participantLimit?: number;
  notes?: string;
  status: 'draft' | 'published' | 'archived';
  createdAt: string;
}

export interface ScheduleItem {
  id: string;
  eventId: string;
  dayDate: string;
  startTime: string;
  endTime?: string;
  title: string;
  description?: string;
  activityType: string;
  /* Risalet-in Nur kütüphanesindeki metnin adresi — okuma satırlarında. */
  link?: string;
  sortOrder: number;
}

export interface Task {
  id: string;
  organizationId: string;
  title: string;
  description?: string;
  status: string;
  notes?: string;
  assignees?: { id: string; fullName: string; email: string }[];
  createdAt: string;
}

export interface Checklist {
  id: string;
  title: string;
  description?: string;
  items: ChecklistItem[];
  generalItems?: ChecklistItem[];
  personalItems?: ChecklistItem[];
}

export interface ChecklistItem {
  id: string;
  title: string;
  sortOrder: number;
  status?: string;
  isPersonal?: boolean;
  userId?: string;
}

export interface Expense {
  id: string;
  userId?: string;
  userName?: string;
  expenseDate: string;
  amount: number;
  description: string;
  category: string;
  receipts?: { id: string; fileUrl: string; fileName?: string }[];
}

export interface ChatMessage {
  id: string;
  userId: string;
  userName: string;
  content?: string;
  messageType: string;
  fileUrl?: string;
  createdAt: string;
}

export interface MediaFile {
  id: string;
  fileUrl: string;
  fileName: string;
  mimeType: string;
  mediaType: string;
  createdAt: string;
}

export const ACTIVITY_LABELS: Record<string, string> = {
  travel: 'Yolculuk',
  breakfast: 'Kahvaltı',
  meal: 'Yemek',
  prayer: 'Namaz',
  lesson: 'Ders',
  reading: 'Okuma',
  personal_reading: 'Şahsi Okuma',
  quran_reading: "Kur'an Okuma",
  mutalaa: 'Mütalaa',
  tefekkur: 'Tefekkür',
  tenezzuh: 'Tenezzüh',
  walk: 'Yürüyüş',
  cemetery_visit: 'Mezarlık Ziyareti',
  rest: 'Dinlenme',
  free_time: 'Serbest Zaman',
  sleep: 'Uyku',
  custom: 'Özel Etkinlik',
};

export const TASK_STATUS_LABELS: Record<string, string> = {
  waiting: 'Bekliyor',
  preparing: 'Hazırlanıyor',
  ready: 'Hazır',
  completed: 'Tamamlandı',
  cancelled: 'İptal Edildi',
};

export const EXPENSE_LABELS: Record<string, string> = {
  transport: 'Ulaşım',
  food: 'Gıda',
  camping: 'Kamp Malzemesi',
  shared: 'Ortak İhtiyaç',
  other: 'Diğer',
};
